export const domain = "http://127.0.0.1:8000/api"
// export const domain = "https://medicalapi.kisrasprint.com/api"
// export const domain = "http://58.137.162.163/service"
// export const domain = "https://backend.rtamed.com/api"

